// ============================================================
// 八字排盘 · 规则表与工具（独立模块，不依赖奇门引擎）
// 口诀均为传统通行法度：
//   天乙贵人「甲戊庚牛羊，乙己鼠猴乡，丙丁猪鸡位，
//             壬癸兔蛇藏，六辛逢马虎」
//   文昌「甲乙巳午报君知，丙戊申宫丁己鸡，
//         庚猪辛鼠壬逢虎，癸人见卯入云梯」
//   禄神「甲禄到寅宫，乙禄居卯中，丙戊宫在巳，
//         丁己居午中，庚禄居于申，辛禄在酉宫，
//         壬禄亥上坐，癸禄在子同」
//   驿马桃花等以三合局起：申子辰／寅午戌／巳酉丑／亥卯未
// ============================================================

export const GAN = ['甲', '乙', '丙', '丁', '戊', '己', '庚', '辛', '壬', '癸'];
export const ZHI = ['子', '丑', '寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥'];

export const GAN_WX = { 甲: '木', 乙: '木', 丙: '火', 丁: '火', 戊: '土', 己: '土', 庚: '金', 辛: '金', 壬: '水', 癸: '水' };
export const ZHI_WX = { 子: '水', 丑: '土', 寅: '木', 卯: '木', 辰: '土', 巳: '火', 午: '火', 未: '土', 申: '金', 酉: '金', 戌: '土', 亥: '水' };

// 三合局：地支 → 局名
const SANHE_KEY = {
  申: 0, 子: 0, 辰: 0,
  寅: 1, 午: 1, 戌: 1,
  巳: 2, 酉: 2, 丑: 2,
  亥: 3, 卯: 3, 未: 3,
};
const SANHE_TABLE = [
  // 马 桃花 华盖 将星 劫煞 灾煞
  { ma: '寅', tao: '酉', hua: '辰', jiang: '子', jie: '巳', zai: '午' }, // 申子辰
  { ma: '申', tao: '卯', hua: '戌', jiang: '午', jie: '亥', zai: '子' }, // 寅午戌
  { ma: '亥', tao: '午', hua: '丑', jiang: '酉', jie: '寅', zai: '卯' }, // 巳酉丑
  { ma: '巳', tao: '子', hua: '未', jiang: '卯', jie: '申', zai: '酉' }, // 亥卯未
];

// 天乙贵人：日干(及年干) → 贵人地支对
const TIAN_YI = {
  甲: ['丑', '未'], 戊: ['丑', '未'], 庚: ['丑', '未'],
  乙: ['子', '申'], 己: ['子', '申'],
  丙: ['亥', '酉'], 丁: ['亥', '酉'],
  壬: ['巳', '卯'], 癸: ['巳', '卯'],
  辛: ['午', '寅'],
};

// 文昌贵人：日干 → 地支
const WEN_CHANG = { 甲: '巳', 乙: '午', 丙: '申', 丁: '酉', 戊: '申', 己: '酉', 庚: '亥', 辛: '子', 壬: '寅', 癸: '卯' };

// 禄神（临官）：日干 → 地支
const LU_SHEN = { 甲: '寅', 乙: '卯', 丙: '巳', 丁: '午', 戊: '巳', 己: '午', 庚: '申', 辛: '酉', 壬: '亥', 癸: '子' };

// 羊刃（阳干帝旺之支）
const YANG_REN = { 甲: '卯', 丙: '午', 戊: '午', 庚: '酉', 壬: '子' };

// 孤辰寡宿（年支起）
const GUAN_TABLE = [
  { zu: '亥子丑', gu: '寅', gua: '戌' },
  { zu: '寅卯辰', gu: '巳', gua: '丑' },
  { zu: '巳午未', gu: '申', gua: '辰' },
  { zu: '申酉戌', gu: '亥', gua: '未' },
];

// 红鸾（年支起，卯位起子逆数）；天喜为其对冲
const HONG_LUAN = { 子: '卯', 丑: '寅', 寅: '丑', 卯: '子', 辰: '亥', 巳: '戌', 午: '酉', 未: '申', 申: '未', 酉: '午', 戌: '巳', 亥: '辰' };

// 魁罡日
const KUI_GANG = ['庚辰', '庚戌', '壬辰', '戊戌'];

// 天德贵人（以月支查四柱干或支）——《三命通会·论天月德》
const TIAN_DE = { 寅: '丁', 卯: '申', 辰: '壬', 巳: '辛', 午: '亥', 未: '甲', 申: '癸', 酉: '寅', 戌: '丙', 亥: '乙', 子: '巳', 丑: '庚' };
// 月德贵人（以月支查四柱天干）
const YUE_DE = { 寅: '丙', 午: '丙', 戌: '丙', 申: '壬', 子: '壬', 辰: '壬', 亥: '甲', 卯: '甲', 未: '甲', 巳: '庚', 酉: '庚', 丑: '庚' };

// 十二长生：日干起长生的地支位置（阴干逆行）
const CHANGSHENG_START = { 甲: '亥', 乙: '午', 丙: '寅', 丁: '酉', 戊: '寅', 己: '酉', 庚: '巳', 辛: '子', 壬: '申', 癸: '卯' };
export const CHANGSHENG_12 = ['长生', '沐浴', '冠带', '临官', '帝旺', '衰', '病', '死', '墓', '绝', '胎', '养'];

// 日干 → 各支十二长生查询表
export function changshengTable(dayGan) {
  const yang = GAN.indexOf(dayGan) % 2 === 0;
  const start = ZHI.indexOf(CHANGSHENG_START[dayGan]);
  const map = {};
  ZHI.forEach((z, i) => {
    let step = (i - start + 12) % 12;
    if (!yang) step = (12 - step) % 12;
    map[z] = CHANGSHENG_12[step];
  });
  return map;
}

// 五行生克
export const SHENG_NEXT = { 木: '火', 火: '土', 土: '金', 金: '水', 水: '木' };
export function keWx(a, b) {
  return SHENG_NEXT[SHENG_NEXT[a]] === b;
}
export function relationWx(a, b) {
  if (!a || !b) return '';
  if (a === b) return '比';
  if (SHENG_NEXT[a] === b) return '生';
  if (SHENG_NEXT[b] === a) return '受生';
  if (keWx(a, b)) return '克';
  if (keWx(b, a)) return '受克';
  return '';
}

/**
 * 以日主（日干）为基准排四柱十神、神煞等
 * @param ec  lunar-javascript 的 EightChar 实例
 */
export function analyzeBazi(ec) {
  const dayGan = ec.getDayGan();
  const pillars = [
    { key: 'year', label: '年柱', gan: ec.getYearGan(), zhi: ec.getYearZhi(), hide: ec.getYearHideGan(), ssGan: ec.getYearShiShenGan(), ssZhi: ec.getYearShiShenZhi(), naYin: ec.getYearNaYin() },
    { key: 'month', label: '月柱', gan: ec.getMonthGan(), zhi: ec.getMonthZhi(), hide: ec.getMonthHideGan(), ssGan: ec.getMonthShiShenGan(), ssZhi: ec.getMonthShiShenZhi(), naYin: ec.getMonthNaYin() },
    { key: 'day', label: '日柱', gan: dayGan, zhi: ec.getDayZhi(), hide: ec.getDayHideGan(), ssGan: '日主', ssZhi: ec.getDayShiShenZhi(), naYin: ec.getDayNaYin() },
    { key: 'time', label: '时柱', gan: ec.getTimeGan(), zhi: ec.getTimeZhi(), hide: ec.getTimeHideGan(), ssGan: ec.getTimeShiShenGan(), ssZhi: ec.getTimeShiShenZhi(), naYin: ec.getTimeNaYin() },
  ];
  const branches = pillars.map(p => p.zhi);

  // ---- 神煞 ----
  const shenSha = [];
  const addSha = (name, hits, base) => {
    if (!hits.length) return;
    const exist = shenSha.find(s => s.name === name);
    if (exist) {
      hits.forEach(h => {
        const pos = `${h.pillar}${h.where}`;
        if (!exist.positions.includes(pos)) exist.positions.push(pos);
      });
      exist.base = exist.base.includes(base) ? exist.base : `${exist.base}＋${base}`;
    } else {
      shenSha.push({ name, base, positions: hits.map(h => `${h.pillar}${h.where}`) });
    }
  };
  const hitBranches = (targets) => {
    const out = [];
    pillars.forEach((p) => {
      if (targets.includes(p.zhi)) out.push({ pillar: p.label, where: '支' });
      if (targets.includes(p.gan)) out.push({ pillar: p.label, where: '干' });
    });
    return out;
  };

  // 天乙贵人（日干、年干双查）
  const tyTargets = [...TIAN_YI[dayGan], ...(TIAN_YI[ec.getYearGan()] || [])];
  addSha('天乙贵人', hitBranches(tyTargets.filter((v, i, a) => a.indexOf(v) === i)), '日干／年干');
  addSha('文昌贵人', hitBranches([WEN_CHANG[dayGan]]), '日干');
  addSha('禄神', hitBranches([LU_SHEN[dayGan]]), '日干');
  if (YANG_REN[dayGan]) addSha('羊刃', hitBranches([YANG_REN[dayGan]]), '日干');

  // 三合局类神煞：年支、日支双查
  [ec.getYearZhi(), dayGan && ec.getDayZhi()].forEach((bz, bi) => {
    if (!bz) return;
    const t = SANHE_TABLE[SANHE_KEY[bz]];
    const tag = bi === 0 ? '年支' : '日支';
    addSha('驿马', hitBranches([t.ma]), tag);
    addSha('桃花', hitBranches([t.tao]), tag);
    addSha('华盖', hitBranches([t.hua]), tag);
    addSha('将星', hitBranches([t.jiang]), tag);
    addSha('劫煞', hitBranches([t.jie]), tag);
    addSha('灾煞', hitBranches([t.zai]), tag);
  });

  // 孤辰寡宿（年支）
  {
    const yz = ec.getYearZhi();
    const row = GUAN_TABLE.find(r => r.zu.includes(yz));
    if (row) {
      addSha('孤辰', hitBranches([row.gu]), '年支');
      addSha('寡宿', hitBranches([row.gua]), '年支');
    }
  }

  // 红鸾天喜（年支）
  {
    const hl = HONG_LUAN[ec.getYearZhi()];
    const txIdx = (ZHI.indexOf(hl) + 6) % 12;
    addSha('红鸾', hitBranches([hl]), '年支');
    addSha('天喜', hitBranches([ZHI[txIdx]]), '年支');
  }

  // 天德贵人（月支查干或支）
  {
    const td = TIAN_DE[ec.getMonthZhi()];
    if (td) addSha('天德贵人', hitBranches([td]), '月支');
  }
  // 月德贵人（月支查天干）
  {
    const yd = YUE_DE[ec.getMonthZhi()];
    if (yd) {
      const hits = pillars.filter(p => p.gan === yd).map(p => ({ pillar: p.label, where: '干' }));
      addSha('月德贵人', hits, '月支');
    }
  }

  // 空亡（日柱旬空）
  {
    const kong = (ec.getDayXunKong() || '').split('');
    addSha('空亡', hitBranches(kong), '日柱旬');
  }

  // 魁罡（日柱）
  if (KUI_GANG.includes(ec.getDayGan() + ec.getDayZhi())) {
    shenSha.push({ name: '魁罡', base: '日柱', positions: ['日柱'] });
  }

  // ---- 五行统计（天干4字＋地支本气4字）----
  const wuxingCount = { 木: 0, 火: 0, 土: 0, 金: 0, 水: 0 };
  pillars.forEach((p) => {
    wuxingCount[GAN_WX[p.gan]] += 1;
    wuxingCount[ZHI_WX[p.zhi]] += 1;
  });
  const missing = Object.keys(wuxingCount).filter(k => !wuxingCount[k]);

  return { dayGan, pillars, shenSha, wuxingCount, missing };
}
